import React, { useState, useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import SidebarRFQ from "../POpage/SidebarRFQ";
import unreadicon from "../assets/images/unreadicon.png";
import timeicon from "../assets/images/timeicon.png";

dayjs.extend(relativeTime);

const AlertMessageall = () => {
  const user = JSON.parse(localStorage.getItem("userdata"));
  const [rfqMessages, setRFQMessages] = useState([]);

  const staticAlerts = [
    {
      title: "Reminder: Submit RFQ response",
      desc: "Your RFQ deadline is approaching. Submit before the due date.",
      unread: true,
      time: "1 hour ago",
    },
    {
      title: "New RFQ Available",
      desc: "A new RFQ has been posted in your category.",
      unread: false,
      time: "2 days ago",
    },
  ];

  useEffect(() => {
    if (user?.id) {
      fetchMessagesRFQ();
    }
  }, []);

  const fetchMessagesRFQ = async () => {
    try {
      const response = await axios.get(
        `https://bimanager.nexteck.uk/api/messagesrfq/${user.id}`
      );
      setRFQMessages(response.data.messages.slice(0, 5));
    } catch (err) {
      console.error("RFQ fetch error:", err);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axios.post(`https://bimanager.nexteck.uk/api/messages/status-update`, {
        id,
        client_id: user.id,
      });
      fetchMessagesRFQ();
    } catch (err) {
      console.error("Status update failed", err);
    }
  };

  const renderMessageCard = (messages) =>
    messages.map((alert) => (
      <div
        key={alert.id}
        className="d-flex justify-content-between align-items-center bglight p-2 mb-3 rounded-3"
        style={{ cursor: "pointer" }}
        onClick={() => markAsRead(alert.id)}
      >
        <div className="d-flex align-items-center">
          <div className="fw-semibold mx-2">{alert.message}</div>
        </div>
        <div className="d-flex justify-content-end align-items-center gap-4">
          <div className="text-center">
            <img src={unreadicon} alt="Unread Icon" style={{ width: "20px", height: "20px" }} />
            <div className="small text-muted mx-2">
              {alert.status === "0" ? "Unread" : "Read"}
            </div>
          </div>
          <div className="text-center">
            <img src={timeicon} alt="Time Icon" style={{ width: "20px", height: "20px" }} />
            <div className="small text-muted mx-2">
              {dayjs(alert.created_at).fromNow()}
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    <div className="row">
      <div className="custom-2-5">
        <SidebarRFQ />
      </div>
      <div className="custom-9-5 dashboardsclooer p-4">
        <h2 className="text-xl fw-bold mb-4">Notifications</h2>
        <div className="card p-4 shadowsm rounded-4">
         
          

          <h6 className="fw-bold mt-4 mb-3">RFQ Messages</h6>
          {renderMessageCard(rfqMessages)}
        </div>
      </div>
    </div>
  );
};

export default AlertMessageall;
